import { ConsultaSeguimentoIndicatorHelper } from '@mchat-rf/consulta-seguimento/components/ConsultaSeguimentoIndicatorHelper'
import { ConsultaSeguimentoIndicatorResultado } from '@mchat-rf/consulta-seguimento/components/ConsultaSeguimentoIndicatorResultado'
import { ConsultaSeguimentoIndicatorStart } from '@mchat-rf/consulta-seguimento/components/ConsultaSeguimentoIndicatorStart'
import { ConsultaSeguimentoPerguntaHeader } from '@mchat-rf/consulta-seguimento/components/ConsultaSeguimentoPerguntaHeader'
import { ConsultaSeguimentoPerguntaHeaderTitle } from '@mchat-rf/consulta-seguimento/components/ConsultaSeguimentoPerguntaHeaderTitle'
import { PerguntaSimNaoRadioListField } from '@mchat-rf/consulta-seguimento/components/PerguntaSimNaoRadioListField'
import { isPerguntaStatusRespondendo } from '@mchat-rf/consulta-seguimento/consulta-seguimento-aplicacao/utils-consultaSeguimentoAplicacao'
import { useConsultaSeguimentoAutoScroll } from '@mchat-rf/consulta-seguimento/hooks/useConsultaSeguimentoAutoScroll'
import { useConsultaSeguimentoSetResultado } from '@mchat-rf/consulta-seguimento/hooks/useConsultaSeguimentoSetResultado'
import { VFlow } from 'bold-ui'
import { RadioOption, resolveName, SimNaoEnum } from 'components/form'
import { SimNaoSwitchButtonField } from 'components/form/field/SimNaoSwitchButtonField'
import { MChatPerguntaEnum } from 'graphql/types.generated'
import { RefObject } from 'react'
import { useField } from 'react-final-form'
import { MetaPath } from 'util/metaPath'

import {
  ConsultaSeguimentoPergunta04GostaDeSubirEmEnum,
  ConsultaSeguimentoPergunta04Model,
} from './model-consultaSeguimentoPergunta04'
import { PERGUNTA_04_SCROLL_CONFIG } from './scrollConfig-consultaSeguimentoPergunta04'
import { calculateResultadoPergunta04, conditionToCalculatePergunta04 } from './utils-consultaSeguimentoPergunta04'

interface ConsultaSeguimentoPergunta04FieldProps {
  name: MetaPath<ConsultaSeguimentoPergunta04Model>
  containerRef: RefObject<HTMLDivElement>
  goNextButtonRef: RefObject<HTMLButtonElement>
}

export function ConsultaSeguimentoPergunta04Field(props: Readonly<ConsultaSeguimentoPergunta04FieldProps>) {
  const { name, containerRef, goNextButtonRef } = props

  const {
    input: { value },
  } = useField<ConsultaSeguimentoPergunta04Model>(resolveName(name), {
    subscription: { value: true },
  })

  useConsultaSeguimentoSetResultado<ConsultaSeguimentoPergunta04Model>({
    name,
    conditionToCalculate: conditionToCalculatePergunta04,
    calculateResultado: calculateResultadoPergunta04,
  })

  const { getId, triggerScrollFor } = useConsultaSeguimentoAutoScroll<ConsultaSeguimentoPergunta04Model>({
    name,
    containerRef,
    goNextButtonRef,
    scrollConfig: PERGUNTA_04_SCROLL_CONFIG,
  })

  return (
    <VFlow>
      {isPerguntaStatusRespondendo(value.status) && (
        <ConsultaSeguimentoPerguntaHeader
          pergunta={MChatPerguntaEnum.PERGUNTA_04}
          title={<ConsultaSeguimentoPerguntaHeaderTitle sufix=' gosta de subir nas coisas?' />}
          status={value.status}
          field={
            <SimNaoSwitchButtonField
              name={name.PERGUNTA_04_HEADER}
              onChange={() => triggerScrollFor('PERGUNTA_04_HEADER')}
            />
          }
        />
      )}
      {value.PERGUNTA_04_HEADER && (
        <VFlow vSpacing={0}>
          <ConsultaSeguimentoIndicatorStart />
          <VFlow id={getId('PERGUNTA_04_GOSTA_DE_SUBIR_EM')}>
            {value.PERGUNTA_04_HEADER === SimNaoEnum.SIM && (
              <ConsultaSeguimentoIndicatorHelper
                title='Por favor, dê um exemplo de alguma coisa na qual ele goste de subir.'
                subtitle='(Se o genitor não der um dos exemplos abaixo, perguntar cada um deles individualmente.)'
              />
            )}
            <PerguntaSimNaoRadioListField<ConsultaSeguimentoPergunta04GostaDeSubirEmEnum>
              name={name.PERGUNTA_04_GOSTA_DE_SUBIR_EM}
              label='Ele gosta de subir em...'
              options={PERGUNTA_04_GOSTA_DE_SUBIR_EM_OPTIONS}
              required
              onChange={() => triggerScrollFor('PERGUNTA_04_GOSTA_DE_SUBIR_EM')}
            />
          </VFlow>
          {value.resultado && (
            <ConsultaSeguimentoIndicatorResultado
              text={{
                FALHOU: 'Não para todos:',
                PASSOU: 'Sim para qualquer um:',
              }}
              resultado={value.resultado}
            />
          )}
        </VFlow>
      )}
    </VFlow>
  )
}

const PERGUNTA_04_GOSTA_DE_SUBIR_EM_OPTIONS: RadioOption<ConsultaSeguimentoPergunta04GostaDeSubirEmEnum>[] = [
  {
    label: 'Escadas?',
    value: ConsultaSeguimentoPergunta04GostaDeSubirEmEnum.ESCADAS,
  },
  {
    label: 'Cadeiras?',
    value: ConsultaSeguimentoPergunta04GostaDeSubirEmEnum.CADEIRAS,
  },
  {
    label: 'Móveis?',
    value: ConsultaSeguimentoPergunta04GostaDeSubirEmEnum.MOVEIS,
  },
  {
    label: 'Brinquedos em parques?',
    value: ConsultaSeguimentoPergunta04GostaDeSubirEmEnum.BRINQUEDOS,
  },
]
